<template>
  <div>
    <p v-if="errorMsg" class="errorMsg">
      {{ errorMsg }}
    </p>
    <div class="opple-ability-ui-com-wifi">
      <div class="opple-ability-ui-com-wifi_label">
        <p> SSID</p>
        <div
          v-show="tag.text"
          class="opple-ability-ui-com-tag"
          :class="tag.class"
        >
          {{ tag.text }}
        </div>
      </div>
      <div class="opple-ability-ui-com-wifi_value">
        <div v-if="nameType === 1" class="opple-ability-ui-com-wifi_value_password">
          <el-select
            v-model="nameSelectValue"
            :placeholder="$t('ifttt.iftttPlaceholder')"
            prefix-icon="el-icon-search"
            @change="handlerNameSelectValue"
          >
            <el-option
              v-for="item in wifiOptions"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            />
          </el-select>
        </div>
        <div v-else class="opple-ability-ui-com-wifi_value_password">
          <el-input
            v-model="nameTextValue"
          />
        </div>
        <div class="opple-ability-ui-com-wifi_control">
          <i
            v-if="nameType === 1"
            class="el-icon-refresh"
            style="cursor: pointer;"
            @click="handlerRefreshBtn"
          />
          <p style="cursor: pointer; margin-left: 5px;" @click="handlerChangeNameType">
            {{ nameType === 1 ? $t('energyBoard.inputCarbonFactor') : $t('energyBoard.inputManualSelection') }}
          </p>
        </div>
      </div>
    </div>
    <div class="opple-ability-ui-com-wifi">
      <div class="opple-ability-ui-com-wifi_label">
        <p> {{ $t('forgetpsw.password') }}</p>
        <div
          v-show="tag.text"
          class="opple-ability-ui-com-tag"
          :class="tag.class"
        >
          {{ tag.text }}
        </div>
      </div>
      <div class="opple-ability-ui-com-wifi_value">
        <div class="opple-ability-ui-com-wifi_value_password">
          <el-input
            :maxlength="63"
            :value="passwordValue"
            :type="isPasswordVisible ? 'text': 'password'"
            :placeholder="$t('base.write')"
            @input="onPasswordChange"
          />
          <img
            :src="isPasswordVisible ? passwordVisibleImg : passwordUnVisibleImg"
            class="eye"
            @click="triggerIsPasswordVisible"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isWifiConfig, ConfigType } from './utils';
import passwordVisibleImg from '@/assets/img/eye_open_login.png';
import passwordUnVisibleImg from '@/assets/img/eye_close_login.png';
import {
  FindActionAbilityWithStatus,
  CallAction
} from '@/axios/IDevice.js'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    device: {
      type: Object,
      default: () => ({})
    },
    actionList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      errorMsg: '',
      nameType: 1,
      nameSelectValue: '',
      nameTextValue: '',
      passwordValue: '',
      tag: {},
      wifiOptions: [],
      isPasswordVisible: true,
      passwordVisibleImg,
      passwordUnVisibleImg,
      isNoPasswordWifi: false,
      KeyId: null
    }
  },

  computed: {
   
  },

  watch: {
    item(val) {
      this.initValue(val);
    }
  },

  mounted() {
    this.initValue(this.item);
  },
   
  methods: {
    handlerRefreshBtn() {
      this.$emit('refreshWifi');
    },

    getData(GpDetails) {
      const data = GpDetails.find(item => 
        item.ValueType === 'Input' && item.UI?.ConfigType === ConfigType.ConfigWiFiNameAndPasswordJson
      );

      const noPasswordData = GpDetails.find(item => 
        item.ValueType === 'UIControl_ConfigWiFiReport_JSON'
      );

      // const noPasswordData = null;

      const wifiList = GpDetails.find(item => 
        item.ValueType === 'UIControl_ConfigWiFiReport_List'
      );

      const hasPasswordData = JSON.parse(data.DefaultValue || '{}');
      const noPasswordDataData = JSON.parse(noPasswordData.DefaultValue || '{}').Info || [];
      const wifiListData = JSON.parse(wifiList.DefaultValue || '{}').Info || [];
      // const wifiListData = JSON.parse(wifiList.DefaultValue || '{}').Info || [];

      if (hasPasswordData && hasPasswordData.SSID && hasPasswordData.PWD) {
        const curData = noPasswordDataData.find(item => item.SSID === hasPasswordData.SSID) || {};

        // if (curData?.InUse === true) {
        //   return {
        //     KeyId: data.KeyId,
        //     isNoPasswordWifi: true,
        //     wifiList: JSON.parse(wifiList.DefaultValue || '{}').Info || [],
        //     data: hasPasswordData
        //   };
        // } else {
        //   return {
        //     KeyId: data.KeyId,
        //     isNoPasswordWifi: true,
        //     wifiList: JSON.parse(wifiList.DefaultValue || '{}').Info || [],
        //     data: hasPasswordData
        //   };
        // }

        const msgData = this.$store.state.errorInfor.find(item => item.Key === `${curData.ErrCode}`);

        const msg = msgData ? msgData.Value : '';

        return {
          KeyId: data.KeyId,
          isNoPasswordWifi: true,
          isSuccess: curData?.InUse === true,
          ResultCode: data.ResultCode,
          msg: msg,
          wifiList: JSON.parse(wifiList.DefaultValue || '{}').Info || [],
          data: hasPasswordData
        };
      }

      if (!!noPasswordDataData) {
        const inUseData = noPasswordDataData.find(item => item.InUse === true);

         return {
          KeyId: noPasswordData.KeyId,
          isNoPasswordWifi: true,
          ResultCode: data?.ResultCode,
          wifiList: wifiListData,
          data: inUseData || {}
        };
      }


      // if (!!noPasswordData) {
      //   const dataList = JSON.parse(noPasswordData.DefaultValue || '{}').Info || [];
      //   const data = dataList.find(item => item.InUse === true);

      //   return {
      //     KeyId: noPasswordData.KeyId,
      //     isNoPasswordWifi: true,
      //     wifiList: JSON.parse(wifiList.DefaultValue || '{}').Info || [],
      //     data: data
      //   };
      // } else {
      //    return {
      //     KeyId: data.KeyId,
      //     isNoPasswordWifi: false,
      //     wifiList: JSON.parse(wifiList.DefaultValue || '{}').Info || [],
      //     data: JSON.parse(data.DefaultValue || '{}')
      //   };
      // }
    },

    async initValue(wifiItem) {
      const actionsRes = await FindActionAbilityWithStatus({
        classSku: this.device.ClassSku,
        vDeviceId: this.device.VDeviceId,
        channelId: this.device.ChildId,
      });

      const actionList = actionsRes.Result || [];
      let actionItem = null;
      let refreshWifiItem = null;

      for (let i = 0; i < actionList.length; i++) {
        const curActionList = actionList[i].ActionList

        for (let j = 0; j < curActionList.length; j++) {
          const curAction = curActionList[j];
          const { UI, Values } = curAction;

          const refreshWifi = Values.find(item => item.ValueType === "UIControl_RefreshWiFiList");

          if (!!refreshWifi) {
            actionItem = curAction;
            refreshWifiItem = refreshWifi;
            break;
          }
        };
      }

      if (!!actionItem?.UI?.AutoCallActionMode && refreshWifiItem && this.device.IsOnline) {
        const data = {
          vDeviceId: this.device.VDeviceId,
          msgType: actionItem.MsgType,
          channelId: this.device.ChildId,
          values: actionItem.Values.map(item => item.DefaultValue).join(',')
        }

        await CallAction(data)
      }
      
      const { GpDetails } = wifiItem;

      const { data, wifiList, isNoPasswordWifi, KeyId, error, msg, ResultCode } = this.getData(GpDetails) || {};

      this.initTag(ResultCode);

      if (!!msg) {
        this.errorMsg = msg;
      } else {
        this.errorMsg = '';
      }

      this.KeyId = KeyId;
      this.isNoPasswordWifi = isNoPasswordWifi;

      try {
        this.nameSelectValue = data.SSID;
        this.passwordValue = data.PWD || '';

        if (this.passwordValue && this.passwordValue.length > 0) {
          this.isPasswordVisible = false;
        }

        this.wifiOptions = (wifiList || []).map(item => ({
          label: item.SSID,
          value: item.SSID
        }));

         if (!!this.nameSelectValue && !this.wifiOptions.some(item => item.label === this.nameSelectValue)) {
          this.nameType = 2;
          this.nameTextValue = data.SSID;
        }
      } catch (e) {
        console.log('json解析失败', e);
      }
    },

    initTag(ResultCode) {
      switch (ResultCode) {
        case 0:
          this.tag = {
            class: 'pedding',
            text: this.$t('deviceMsg.configing')
          };
          break;
        case 1:
          this.tag = {
            class: 'success',
            text: this.$t('deviceMsg.configsuccess')
          };
          break;
        case 2:
          this.tag = {
            class: 'fail',
            text: this.$t('deviceMsg.configfail')
          };
          break;
        default:
          this.tag = {
            class: 'default',
            text: this.$t('deviceMsg.configdefault')
          };
      }
    },
    validate() {
      const { nameType, nameTextValue, nameSelectValue, passwordValue } = this;
  

      const name = nameType === 1 ? nameSelectValue : nameTextValue;

      if (!name) {
        return {
          status: false,
          msg: this.$t('sylogs.plhode3')
        };
      }; 

      if (!!passwordValue && passwordValue.length < 8) {
        return {
          status: false,
          msg: this.$t('deviceMsg.lengthLimit2').replace('{Min}', 8).replace('{Max}', 63),
        };
      };
    
      return {
        status: true,
      }
    },

    handlerChangeNameType() {
      if (this.nameType === 1) {
        this.nameType = 2;
      } else {
        this.nameType = 1;
      }
    },
    onNameChange() {

    },
    onPasswordChange(value) {
      if (/^[^\u4e00-\u9fa5\s\n]*$/.test(value)) {
        console.log('onPasswordChange 1');
        
        this.passwordValue = value;
      }
    },
    triggerIsPasswordVisible() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },

    handlerNameSelectValue() {
      this.passwordValue = '';
    },

    getFormData() {
      const { GpDetails } = this.item;
      const { nameType, nameTextValue, nameSelectValue, passwordValue } = this;

      const data =  GpDetails.find(item => 
        item.ValueType === 'Input' && item.UI?.ConfigType === ConfigType.ConfigWiFiNameAndPasswordJson
      );

      // let ConfigItems = [];

      // const nameValue = nameRenderType === 1? this.nameSelectValue : this.nameInputValue;

      // ConfigItems.push({
      //   Key: nameSelectItem.KeyId,
      //   Values: [ nameValue ]
      // });

      // ConfigItems.push({
      //   Key: passwordSelectItem.KeyId,
      //   Values: [ passwordValue ]
      // });

      let reqData = {
        VDeviceId: this.device.VDeviceId,
        GpNo: this.item.GpNo,
        ConfigItems: [{
          Key: data.KeyId,
          Values: [
            JSON.stringify({
              SSID: nameType === 1 ? nameSelectValue : nameTextValue,
              PWD: passwordValue
            })
          ]
        }]
      }

      return reqData;
    },
  },
};
</script>

<style lang="scss" scoped>
  .errorMsg {
    padding-bottom: 10px;
    padding-right: 50px;
    color: red;
    line-height: 19px;
  }

.opple-ability-ui-com-wifi {
  display: flex;
  justify-content: space-between;
  padding-right: 50px;


  &_label {
    display: flex;
    align-items: center;
  }

  &_control {
    display: flex;
    align-items: center;
  }

  &_value {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    &_name {
      display: flex;
      align-items: center;

      &_select {
        width: 180px;
        .el-select {
          width: 100%;
        }
      }

      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }

      img {
        padding-left: 10px;
        padding-right: 10px;
      }

      &_loading.active {
        animation: rotate infinite linear 2s;
      }

      &_pen {
        
        border-left: 1px solid #eee;
      }

      img {

      }

      &_input {
        width: 180px;
      }

      i {
        margin-right: 10px;

        // &.el-icon-edit {
        //   padding-left: 10px;
        //   border-left: 1px solid #eee;
        // }
      }
    }

    &_password {
      display: flex;
      position: relative;
      width: 180px;
      margin-top: 10px;

      img {
        position: absolute;
        right: 9px;
        top: 15px;
      } 
    }
  }

  .opple-ability-ui-com-tag {
    font-size: 12px;
    border-radius: 4px;
    padding: 0 4px;
    margin-left: 8px;
    line-height: 20px;

    &.success {
      border: 1px solid #67c23a;
      color: #67c23a;
    }

    &.pedding {
      border: 1px solid #286fe8;
      color: #286fe8;
    }

    &.fail {
      border: 1px solid #e6a23c;
      color: #e6a23c;
    }

    &.default {
      border: 1px solid #67c23a;
      color: #67c23a;
    }
  }
}

</style>
